import { PILLARS, getScoreColor, calculateNextIndex } from '../utils/scoring';

export default function ReAuditComparison({ currentAudit, previousAudit }) {
  if (!previousAudit) return null;

  const currentIndex = calculateNextIndex(currentAudit.scores);
  const previousIndex = calculateNextIndex(previousAudit.scores);
  const indexDelta = currentIndex - previousIndex;

  return (
    <div className="card p-6 border-gold-400/20">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 rounded-lg bg-gold-400/20 flex items-center justify-center">
          <span className="text-gold-400 text-sm">↔</span>
        </div>
        <div>
          <h3 className="font-bold text-white text-lg">Re-Audit Comparison</h3>
          <p className="text-xs text-navy-400">Tracking changes since last assessment</p>
        </div>
      </div>

      {/* Overall delta */}
      <div className="bg-navy-800/50 rounded-lg p-4 mb-5 text-center">
        <p className="text-xs text-navy-400 mb-1">Next Index Movement</p>
        <div className="flex items-center justify-center gap-4">
          <span className="text-lg text-navy-400">{previousIndex.toFixed(1)}</span>
          <span className={`text-3xl font-black ${indexDelta > 0 ? 'text-emerald-400' : indexDelta < 0 ? 'text-red-400' : 'text-navy-400'}`}>
            → {currentIndex.toFixed(1)}
          </span>
          <span className={`text-sm font-bold px-2 py-0.5 rounded-full ${
            indexDelta > 0 ? 'bg-emerald-500/20 text-emerald-400' : indexDelta < 0 ? 'bg-red-500/20 text-red-400' : 'bg-navy-700 text-navy-400'
          }`}>
            {indexDelta > 0 ? '+' : ''}{indexDelta.toFixed(1)}
          </span>
        </div>
      </div>

      {/* Pillar-by-pillar comparison */}
      <div className="space-y-2">
        {PILLARS.map(pillar => {
          const curr = currentAudit.scores[pillar.id]?.score || 0;
          const prev = previousAudit.scores[pillar.id]?.score || 0;
          const delta = curr - prev;
          const color = getScoreColor(curr);

          return (
            <div key={pillar.id} className="flex items-center gap-3 px-3 py-2 bg-navy-800/30 rounded-lg">
              <span className="text-xs text-navy-300 flex-1 truncate">{pillar.name}</span>
              <span className="text-xs text-navy-500 w-10 text-right">{prev.toFixed(1)}</span>
              <span className="text-navy-600">→</span>
              <span className={`text-xs font-bold w-10 text-right ${color.text}`}>{curr.toFixed(1)}</span>
              <span className={`text-xs font-bold w-12 text-right ${
                delta > 0 ? 'text-emerald-400' : delta < 0 ? 'text-red-400' : 'text-navy-500'
              }`}>
                {delta > 0 ? '↑' : delta < 0 ? '↓' : '='} {Math.abs(delta).toFixed(1)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
